import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

function getMedEntitlement(context) {
    const SessionStore = context.getStore('Session');
    const npi = SessionStore.getNpi();
    const hasEntitlement = SessionStore.hasEntitlement('medications');
    const facility = SessionStore.getFacility ? SessionStore.getFacility() : null;
    const facilityId = facility ? facility.getId() : null;

    const ActiveTenantStore = context.getStore('ActiveTenantStore');
    const activations = ActiveTenantStore.getActivations();

    const activeActivations = (activations || []).filter((a) => a.active);

    const activationsWithFacilityData = activeActivations.filter((a) =>
        !isEmpty(get(a, 'attributes.facilityIds')),
    );

    const relevantActivations =
        activationsWithFacilityData.length > 0
            ? activationsWithFacilityData.filter((a) =>
                  get(a, 'attributes.facilityIds', []).includes(facilityId),
              )
            : activeActivations;

    const medicationQueryEnabled =
        relevantActivations.length > 0 &&
        relevantActivations.every((a) =>
            get(a, 'attributes.medicationQueryEnabled', false),
        );

    return hasEntitlement && !isEmpty(npi) && medicationQueryEnabled;
}

export default getMedEntitlement;
